import React from 'react';
import { ButtonToolbar, Col, Row, Well , Button, Panel} from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import forEach from 'lodash/forEach';
import { toastr, actions as toastrActions } from 'react-redux-toastr';
//import RunGoogleMap from '../components/RunGoogleMap';
import RunToyotaMap from '../components/RunToyotaMap';
import RunInfo from '../components/RunInfo';
import StopsList from '../components/StopsList';
import AbnormalitiesList from '../components/AbnormalitiesList';
import {
    loadRun,
    silentFetchRun,
    getRunById,
    getIsFetching,
    clearErrorMessage,
    updateLocationManually,
} from '../../duck';
import { isRecentlyUpdated, getAbnormalityToastrs } from '../../../abnormalities/duck';
import AuthorizedComponent from '../../../../components/AuthorizedComponent';
import { ROLES } from '../../../../constants';
import { createRunDetailBreadcrumb } from '../../../../shared/utils/breadcrumbs';
import Loader from '../../../../components/Loader/index';
import StopsListModal from '../components/StopListModal';
import reduce from 'lodash/reduce';
import moment from 'moment';
import queryString from 'query-string';

const toastrOptions = {
    timeOut: 0,
    icon: <i style={{ margin: 20 }} className="fa fa-spinner fa-pulse fa-2x fa-fw" />,
};

class Run extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAbnormalitySelectionModal: false,
            showRunStopsModal: false,
            selectedStop: '',
            stops: [],
        };
    }

    componentWillMount() {
        this.props.loadRun(this.props.params.id);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.toastrs !== nextProps.toastrs) {
            this.manageToastrs(nextProps.toastrs);
        }
    }

    componentWillUnmount() {
        this.props.clearErrorMessage();
    }

    manageToastrs = toastrs => {
        forEach(toastrs, t => {
            if (t.type === 'create_blowout_abnormality') {
                this.props.toastr.add({
                    id: `${t.id}_info`,
                    type: 'info',
                    position: 'top-right',
                    title: 'Creating abnormality...',
                    attention: true,
                    options: toastrOptions,
                });
            }
        });
    };

    handleStopHover = stop => {
        // console.log('You hovered over stop ' + stop.stopNumber);
        // console.log('We should now zoom to stop location and show the InfoWindow');
    };

    handleStopsLeave = () => {
        // console.log('Your cursor has left the stops table');
        // console.log('We should now hide the InfoWindow and fit the map to bounds again');
    };

    handleCreateAbnormalityClick = () => {
        this.setState({ showAbnormalitySelectionModal: true });
    };

    handleCloseAbnormalitySelectionModal = () => {
        this.setState({ showAbnormalitySelectionModal: false });
    };

    handleUpdateLocationManually = data => {
        this.props.toastr.add({
            id: 'updatingStop',
            type: 'info',
            title: 'Updating stop...',
            position: 'top-right',
            attention: true,
            message: '',
            options: {},
        });
        this.props.updateLocationManually(data).then(response => {
            if (!response.error) {
                setTimeout(() => {
                    this.props
                        .silentFetchRun(this.props.run.runId)
                        .then(() => this.props.toastr.remove('updatingStop'));
                }, 1000);
            } else {
                toastr.error('Could not update stop...');
                this.props.toastr.remove('updatingStop');
            }
        });
    };

    handleExportUnloadAndLoadSheetClick = () => {
        this.setState({ showRunStopsModal: true });
    };

    handleExportUnloadAndLoadSheetModalClose = () => {
        this.setState({ showRunStopsModal: false });
    };

    handleSelectedStop = r => {
        this.setState({selectedStop : r});
    }

    handleDownloadClick = () => {


    }


    componentDidUpdate(prevProps) {
        if (prevProps.runId !== this.props.runId && this.props.runId) {
            this.props.loadRun(this.props.runId);
            this.setState({
                stops: [],
            });
        }
        if (this.props.run !== prevProps.run && this.props.run) {
            let stops = this.props.run.wayPoints
                ? reduce(this.props.run.wayPoints, (stops, wp) => stops.concat(wp.stops), [])
                : null;
            this.setState({
                stops: stops,
            });
        }
    }

    prepareFormDataForPost = (props) => {
        let param = {
            runId : '',
            fileName : ''
        }
        param.runId = props.run.runId;
        param.fileName = 'EPS_Report_'+props.run.routeCode+' - '+props.run.runDate+' - '+props.run.runSequence+moment().format('DD_MM_YYYY-H_mm');
        return queryString.stringify(param);
    }

    render() {
        const { run, isFetching } = this.props;

        if (isFetching || !run) {
            return <Loader />;
        }

        return (
            <div>
                {run && createRunDetailBreadcrumb(run)}
                <Row>
                    <Col xs={12} lg={6}>
                        <RunInfo run={run} />
                        <StopsList
                            handleStopHover={this.handleStopHover}
                            handleStopsLeave={this.handleStopsLeave}
                            run={run}
                            onUpdateLocationManually={this.handleUpdateLocationManually}
                        />
                    </Col>
                    <Col xs={12} lg={6}>
                        <RunToyotaMap
                            runId={run.runId}
                            stops={run.wayPoints}
                            gpsLocations={run.gpsLocations}
                            lastGpsLocation={run.lastGpsLocation}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <AbnormalitiesList
                            isRecentlyUpdated={this.props.isRecentlyUpdated}
                            run={run}
                            runId={this.props.params.id}
                            showAbnormalitySelectionModal={this.state.showAbnormalitySelectionModal}
                            onCreateAbnormalityClick={this.handleCreateAbnormalityClick}
                            onCloseAbnormalitySelectionModal={
                                this.handleCloseAbnormalitySelectionModal
                            }
                            handleAbnormalityClick={this.handleAbnormalityClick}
                        />
                    </Col>
                </Row>
                <AuthorizedComponent
                    requiredRoles={[ROLES.RUN_DETAILS_TME_EDITOR, ROLES.MANIFEST_DETAIL_VIEWER]}
                >
                    <Row>
                        <Col xs={12}>
                            <Well>
                                <ButtonToolbar>
                                    <Link
                                        to={{
                                            pathname: '/manifests',
                                            query: {
                                                routeCode: run.routeCode,
                                                runDate: run.runDate,
                                                runSequence: run.runSequence,
                                            },
                                        }}
                                        className={'btn btn-primary'}
                                    >
                                        View manifests
                                    </Link>
                                </ButtonToolbar>
                            </Well>
                        </Col>
                    </Row>
                </AuthorizedComponent>
                <AuthorizedComponent
                    requiredRoles={[ROLES.RUN_DETAILS_TME_EDITOR, ROLES.MANIFEST_DETAIL_VIEWER]}
                >
                <Panel header="Run Based Manifests Reports">
                    <Row>
                        <Col sm={12}>
                            <Well>
                                <ButtonToolbar>
                                    <Button
                                        bsStyle="primary"
                                        style={{ marginTop: 10 }}
                                        onClick={this.handleExportUnloadAndLoadSheetClick}
                                    >
                                        Export U/L Sheet
                                    </Button>
                                    <Button
                                        bsStyle="primary"
                                        style={{ marginTop: 10 }}
                                        href={`api/download-brexit-pdf?${this.prepareFormDataForPost(this.props)}`}
                                    >
                                        Generate EPS Report
                                    </Button>
                                </ButtonToolbar>
                            </Well>
                        </Col>
                    </Row>
                </Panel>
                </AuthorizedComponent>
                {this.state.showRunStopsModal &&
                    <StopsListModal
                        showModal={this.state.showRunStopsModal}
                        stops={this.state.stops}
                        onCloseModal={this.handleExportUnloadAndLoadSheetModalClose}
                        onStopSelection={this.handleSelectedStop}
                        selectedStopfromChild={this.handleDownloadClick}
                        runId={run.runId}
                    />}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    loadRun: bindActionCreators(loadRun, dispatch),
    silentFetchRun: bindActionCreators(silentFetchRun, dispatch),
    toastr: bindActionCreators(toastrActions, dispatch),
    clearErrorMessage: bindActionCreators(clearErrorMessage, dispatch),
    updateLocationManually: bindActionCreators(updateLocationManually, dispatch),
});

export default connect(
    (state, ownProps) => ({
        run: getRunById(state, ownProps.params.id),
        isFetching: getIsFetching(state),
        isRecentlyUpdated: isRecentlyUpdated(state),
        toastrs: getAbnormalityToastrs(state),
    }),
    mapDispatchToProps
)(Run);
